import { toast } from 'react-toastify';
import i18n from '../i18n';
import { showRequestError } from './requestError';

// What a list shows after its actor search failed: "no data" instead of an endless loader.
export const EMPTY_ACTORS_RESULT = { objects: [], total: 0, page: 1, size: 0 };

// How a failed actor search should be reported.
//  'ignore'   superseded by a newer request (our own abort) — not an error
//  'slow'     504 from the backend or the client-side deadline
//  'filters'  422: the search has no narrowing filter (e.g. every status deselected)
//  'generic'  anything else
export const actorSearchErrorKind = (error) => {
  if (error?.name === 'AbortError') return 'ignore';
  if (error?.name === 'TimeoutError' || error?.status === 504) return 'slow';
  if (error?.status === 422) return 'filters';
  return 'generic';
};

// Tells the user why the actor search failed. Returns false when there is nothing to report
// (an aborted request), so the caller keeps waiting for the request that replaced it.
export function showActorSearchError(error, context) {
  const kind = actorSearchErrorKind(error);
  if (kind === 'ignore') return false;

  if (kind === 'slow') {
    toast.error(i18n.t('Search took too long — narrow the filters'));
  } else if (kind === 'filters') {
    toast.error(i18n.t('Select at least one filter, for example a status, to see actors'));
  } else {
    showRequestError(error, context);
  }
  return true;
}
